import { Systems } from "./systems";

export enum LOINCCodes {
  BloodPressure = "41904-4",
  DiastolicBloodPressure = "8462-4",
  SystolicBloodPressure = "8480-6",
  DeliveryDateEstimated = "11778-8",
  Edema = "44966-0",
  FetalHeartRate = "55283-6",
  FetalMovement = "57088-7",
  FetalPosition = "11877-8",
  FundalHeight = "11881-0",
  HeartRate = "8867-4",
  RespiratoryRate = "9279-1",
  LastMenstrualPeriodStartDate = "8665-2",
  RoutinePrenatalPanel = "100230-2",
  UrineGlucose = "2349-9",
  UrineProteinTestStrip = "2887-8",
  WeightMeasured = "3141-9",
  LaborStage = "57071-3",
  LaborVitalSigns = "8716-3",
  BodyTemperature = "8310-5",
  NParity = "11977-6",
  NPregnancies = "11996-6",
  NFullTerm = "11639-2",
  NPremature = "11637-6",
  NAbortions = "11612-9",
  NAbortionsInduced = "11613-7",
  NMiscarriages = "11614-5",
  NLivingChildren = "11638-4",
  OutcomeOfPregnancy = "63893-2",
  GestationalAge = "18185-9",
  LocationSite = "85712-8",
  LocationSiteOther = "LA46-8",
  EstimatedBloodLoss = "55103-6",
  QuantitativeBloodLoss = "81661-1",
  CumulativeBloodLoss = "9110-8",
  DeliveryDateEstimatedFromLMP = "11779-6",
  DeliveryDateEstimatedFromUS = "11781-2",
  UltrasoundDate = "34970-4",
  EducationalLevel = "LL1069-5",
  Occupation = "21843-8",
  SpiritualBeliefs = "81364-2",
  PrenatalFlowSheet = "57073-9",
  PrenatalEncounterType = "LP135482-0",
  GACompositeFromUS = "11888-5",
  LMPReliability = "53661-5",
  Antepartum = "LP94462-6",
  Postpartum = "LP20597-8",
  Newborn = "LP7744-8",
  EDDWrapper = "57060-6",
  LaboratoryReport = "11502-2",
  BloodTypePanel = "34531-4",
  ABOGroup = "883-9",
  RhType = "10331-7",
  ABOGroupA = "LA19710-5",
  ABOGroupB = "LA19709-7",
  ABOGroupO = "LA19708-9",
  ABOGroupAB = "LA28449-9",
  RhPositive = "LA6576-8",
  RhNegative = "LA6577-6",
  LaborAndDeliveryEncounter = "57083-8",
  TransferOfCareEncounter = "104920-4",
  EducationNote = "34895-3",
}

export enum LOINCAnswerCodes {
  ProdromalLabor = "LA20664-0",
  EarlyLabor = "LA20665-7",
  ActiveLabor = "LA20666-5",
  SecondStageLabor = "LA20667-3",
  TemperatureMethod = "LL3155-0",
  Yes = "LA33-6",
  No = "LA32-8",
  Unknown = "LA4489-6",
  AmnioticFluid = "LA30056-8",
  Normal = "LA6626-1",
  NotNormal = "LA12748-2",
}

export enum LOINCValueSets {
  EncounterType = `${Systems.LOINC}/vs/LL3016-4`,
  PersonalPronouns = `${Systems.LOINC}/vs/LL5144-2`,
  SexualOrientation = `${Systems.LOINC}/vs/LL3323-4`,
  TemperatureMethod = `${Systems.LOINC}/vs/LL3155-0`,
  GenderIdentity = `${Systems.LOINC}/vs/LL3322-6`,
  Race = `${Systems.LOINC}/LL32624-9`,
  AdministeredMedicationRoute = `${Systems.LOINC}/vs/18612-2`,
  PregnancyOutcome = `${Systems.LOINC}/vs/LL1475-4`,
}
